import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../localization/LocalizationContext";

function IpConfiguration({ vlanData, setVlanData }) {
  const navigate = useNavigate();
  const { localizationStrings } = useLocalization();

  return (
    <div>
      <h4>{localizationStrings?.ipConfiguration}</h4>
      <p>{localizationStrings?.ipModesInfo}</p>
      <div className="vlan-text">
        <p>
          <strong>{localizationStrings?.none}:</strong>{" "}
          {localizationStrings?.ipConfigInfo}{" "}
          <i className="fa fa-angle-right" aria-hidden="true"></i> IP Settings.
          <br />
          <strong>{localizationStrings?.static}:</strong>{" "}
          {localizationStrings?.ipStaticInfo}
          <br />
          <strong>DHCP:</strong> {localizationStrings?.ipDynamicInfo}
        </p>
      </div>
      <div className="row mt-4">
        <div className="col-lg-2">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="vlan"
              id="lan1"
              checked={vlanData.ipMode === "DHCP"}
              onChange={() =>
                setVlanData((prev) => ({ ...prev, ipMode: "DHCP" }))
              }
            />
            <label className="form-check-label" htmlFor="lan1">
              DHCP
            </label>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="vlan"
              id="lan2"
              checked={vlanData.ipMode === "static"}
              onChange={() =>
                setVlanData((prev) => ({ ...prev, ipMode: "static" }))
              }
            />
            <label className="form-check-label" htmlFor="lan2">
              {localizationStrings?.static}
            </label>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="vlan"
              id="lan3"
              checked={vlanData.ipMode === "none" || !vlanData.ipMode}
              onChange={() =>
                setVlanData((prev) => ({ ...prev, ipMode: "none" }))
              }
            />
            <label className="form-check-label" htmlFor="lan3">
              {localizationStrings?.none}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
export default IpConfiguration;
